import React, { useState } from "react";
import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import "./DeferredYouTubePlayer.css";

/** No third-party request until the visitor explicitly loads the player. */
export default function DeferredYouTubePlayer({ src, title }) {
  useSourceLanguage();
  const [loadedSource, setLoadedSource] = useState(null);
  let valid = false;
  try {
    const url = new URL(src);
    valid = url.protocol === "https:" && !url.username && !url.password && !url.port
      && ["www.youtube-nocookie.com", "www.youtube.com"].includes(url.hostname)
      && /^\/embed\/[A-Za-z0-9_-]+$/.test(url.pathname);
  } catch (_) { /* An invalid player never creates an iframe. */ }
  if (!valid) return null;
  return <div className="deferred-youtube">
    {loadedSource === src ? <iframe src={src} title={title} loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      allow="encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share" allowFullScreen /> :
      <div className="deferred-youtube__preview">
        <span aria-hidden="true">▶</span>
        <p>{title}</p>
        <button type="button" onClick={() => setLoadedSource(src)}><LocalizedText source="Charger le lecteur YouTube" /></button>
        <small><LocalizedText source="Le lecteur externe se charge uniquement à votre demande." /></small>
      </div>}
  </div>;
}
